import { render, staticRenderFns } from "./CategoryMenuGroupSuccessOverlay.vue?vue&type=template&id=885bc92a"
import script from "./CategoryMenuGroupSuccessOverlay.vue?vue&type=script&lang=js"
export * from "./CategoryMenuGroupSuccessOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports